module.exports = __webpack_public_path__ + "img/yctiwy-12.129a28ad.jpg";